import { Injectable } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { selectCurrentUserCompanyId } from '../../../../current-user/store/current-user.selectors';
import { filter } from 'rxjs/operators';
import { inputIsNotUndefined } from '../../../../data-access/input-is-not-null-or-undefined';
import { getFirstContactForAccount$ } from '../../../../data-access/contacts';
import { Firestore } from '@angular/fire/firestore';
import { Contact } from '../../../../models/contact';

@Injectable({
  providedIn: 'root',
})
export class GetFirstContactForAccountService {
  constructor(private store$: Store, private firestore: Firestore) {
  }

  get(accountId: string): Observable<Contact | undefined> {
    return this.store$.pipe(
      select(selectCurrentUserCompanyId),
      filter(inputIsNotUndefined),
      switchMap(companyId => getFirstContactForAccount$(this.firestore, companyId, accountId)),
    );
  }
}
